import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  CREATE_SERVICE_FAILED_NETWORK_ERROR
} from '../../../constants';
import { IServiceExceptionResponseModel } from '../../../models/index';

export interface Service {
  isLoading: boolean;
  serviceExceptionErrorMessage: string;
  serviceExceptionList: IServiceExceptionResponseModel[];
  pageNo: number
}

/**
 * Initial Service Exception state in store
 */
const initialState: Service = {
  isLoading: false,
  serviceExceptionErrorMessage: '',
  serviceExceptionList: [],
  pageNo: 0,
};

const getServiceExceptionListSlice = createSlice({
  name: 'getServiceExceptionList',
  initialState,
  reducers: {
    getServiceExceptionListStartedState: (state) => {
      state.isLoading = true;
    },

    getServiceExceptionListSuccessState: (
      state,
      action: PayloadAction<IServiceExceptionResponseModel[]>
    ) => {
      state.isLoading = false;
      state.serviceExceptionList = [...action.payload].reverse();
      state.serviceExceptionErrorMessage = '';
    },

    getServiceExceptionListFailState: (state) => {
      state.isLoading = false;
      state.serviceExceptionList = initialState.serviceExceptionList;
      state.serviceExceptionErrorMessage = CREATE_SERVICE_FAILED_NETWORK_ERROR;
    },

    updatePageNo: (state, action: PayloadAction<number>) => {
      state.pageNo = action.payload;
    },

    clearPageNo: (state) => {
      state.pageNo = initialState.pageNo;
    },

    clearServiceExceptionListState: (state) => {
      state.isLoading = false;
      state.serviceExceptionList = initialState.serviceExceptionList;
      state.serviceExceptionErrorMessage = '';
    }
  }
});
export const {
  getServiceExceptionListStartedState,
  getServiceExceptionListSuccessState,
  getServiceExceptionListFailState,
  clearServiceExceptionListState,
  updatePageNo,
  clearPageNo,
} = getServiceExceptionListSlice.actions;
export default getServiceExceptionListSlice.reducer;
